// ─── TRACKER FUNNEL ─────────────────────────────────────────────────────────
// Wrapper autour de track() de Vercel Analytics. Envoie chaque event À LA FOIS :
//   1. à Vercel Analytics (comportement existant, inchangé)
//   2. à notre Worker Cloudflare → Analytics Engine (gratuit, visible dans l'admin)
// Ainsi on voit le funnel sans payer Vercel Pro. Fire-and-forget : ne bloque ni
// ne fait jamais planter l'UI (tout est dans des try/catch).
// Pour basculer un appel `track(...)` sur ce tracker : importer depuis "./track"
// au lieu de "@vercel/analytics".

import { track as vercelTrack } from "@vercel/analytics";

const WORKER_URL =
  process.env.REACT_APP_WORKER_URL ||
  "https://cruisehunter-proxy.YOUR_SUBDOMAIN.workers.dev";

// Pont vers le Pixel Meta (Facebook/Instagram). Les events à haute intention sont
// mappés sur des events STANDARD Meta (utilisés pour l'optimisation des pubs et les
// audiences lookalike). Tous les autres events du funnel partent en event CUSTOM :
// on pourra créer une « conversion personnalisée » dessus dans le Gestionnaire Meta
// sans retoucher le code. Fire-and-forget, jamais bloquant.
const FB_STANDARD = {
  welcome_funnel_click: "Search",      // a lancé une recherche
  offer_clicked: "Lead",               // a cliqué une offre affiliée (action $$)
  manual_save_click: "AddToWishlist",  // a sauvegardé une croisière
};

function fbTrack(event, props) {
  try {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    const std = FB_STANDARD[event];
    if (std) {
      window.fbq("track", std, props || {});
    } else {
      window.fbq("trackCustom", event, props || {});
    }
  } catch {}
}

export function track(event, props = {}) {
  try { vercelTrack(event, props); } catch {}
  fbTrack(event, props);
  try {
    const lang =
      (typeof document !== "undefined" && document.documentElement.lang) || "";
    const label =
      props && Object.keys(props).length ? JSON.stringify(props).slice(0, 200) : "";
    const payload = JSON.stringify({ action: "track", event, lang, label });
    // text/plain → pas de préflight CORS ; le Worker parse quand même en JSON.
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(WORKER_URL, new Blob([payload], { type: "text/plain" }));
    } else if (typeof fetch !== "undefined") {
      fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {}
}
